import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { ConfigService } from "services/config";
import { DateService } from "services/date/DateService";
import {
    EmploymentPeriod,
    EmploymentPeriods,
} from "models/users/EmploymentPeriod";

@Injectable()
export class UserEmploymentPeriodService {
    constructor(
        private http: HttpClient,
        private configService: ConfigService
    ) {}

    public getEmploymentPeriods(
        userId: string
    ): Observable<EmploymentPeriod[]> {
        return this.http
            .get(this.configService.userEmploymentPeriods(userId))
            .pipe(
                map(
                    (response) =>
                        EmploymentPeriods.parse(response).employmentPeriods
                )
            );
    }

    public addEmploymentPeriod(
        userId: string,
        startDate: Date,
        endDate: Date | null
    ): Observable<void> {
        const payload = {
            startDate: DateService.toISOString(startDate),
            endDate: endDate ? DateService.toISOString(endDate) : null,
        };
        return this.http
            .post(this.configService.userEmploymentPeriods(userId), payload)
            .pipe(map(() => undefined));
    }

    public updateEmploymentPeriod(
        userId: string,
        periodId: number,
        startDate: Date,
        endDate: Date | null
    ): Observable<void> {
        const payload = {
            startDate: DateService.toISOString(startDate),
            endDate: endDate ? DateService.toISOString(endDate) : null,
        };
        return this.http
            .put(
                this.configService.userEmploymentPeriod(userId, periodId),
                payload
            )
            .pipe(map(() => undefined));
    }

    public deleteEmploymentPeriod(
        userId: string,
        periodId: number
    ): Observable<void> {
        return this.http
            .delete(this.configService.userEmploymentPeriod(userId, periodId))
            .pipe(map(() => undefined));
    }
}
